import { ref } from "vue"
import ComponentesService from "@/services/ComponentesService"
import StatusComponenteConstant from "@/constants/StatusComponenteConstant";

class ComponenteAcessorioService {
    setup({ respostas, respostaObrigatoria, etapaComponente, identificador, opcoes, modulo, resumoModulos }) {
        const acessoriosEquipamentos = ref(respostas || {});
        const statusResposta = ref(StatusComponenteConstant.NAO_PREENCHIDO.chave);

        if (!resumoModulos) {
            if (respostas !== null) {
                statusResposta.value = this.controlarStatus(respostaObrigatoria, etapaComponente, identificador, modulo);
            } else {
                const acessoriosIniciais = Object.fromEntries(
                    Object.entries(opcoes).map(([key, item]) => [key, { item, estado: 'ausente' }])
                );
                acessoriosEquipamentos.value = acessoriosIniciais;
                ComponentesService.salvarRespostaEstadoComponente(modulo, etapaComponente, identificador, acessoriosEquipamentos.value);
            }
        }

        return { acessoriosEquipamentos, statusResposta };
    }

    controlarStatus(respostaObrigatoria, etapaComponente, identificador, modulo) {
        const statusResposta = ComponentesService.validaStatusRespostaComponente(respostaObrigatoria, true);
        ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta);
        return statusResposta;
    }
}

export default new ComponenteAcessorioService();